<template>
    <div>
        <!-- BradCrumb header Start-->
        <section class="inner-header-bg">
            <div class="container">
                <div class="section-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 justify-content-center align-self-center pb-2">
                                <div class="breadcrumb-content">
                                    <div class="title-section">
                                        <h1 class="title text-center text-white">Secure Video Surveillance for Your Operations</h1>
                                    </div>
                                    <div class="breadcrumb-nav">
                                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                                            <li class="text-white"><router-link to="/">Home</router-link></li>
                                            <li class="text-white active">Camera & NVR Systems</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- BradCrumb header End -->
        <!-- Start Content -->
        <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h2>Visibility and Security for Your Assets</h2>
                        <p>Professional video surveillance is more than just a deterrent; it's a critical tool for security, safety, and operational oversight. We design and install commercial-grade IP camera and NVR (Network Video Recorder) systems for industrial, commercial, and multi-site operations across South Texas. Our expertise is in ensuring the network supporting your cameras is as secure and reliable as the cameras themselves.</p>
                        
                        <h2>Our Camera & NVR Services</h2>
                        
                        <h3>System Design & Installation</h3>
                        <p>We assess your facility to design a system with the right cameras, lenses, and placement to cover your critical areas. We manage the complete installation, including cabling and NVR setup.</p>

                        <h3>Secure Network Integration</h3>
                        <p>Your camera system should never compromise your primary business network. We place camera and NVR systems on their own segmented, secure network, isolated from your sensitive data to prevent security holes.</p>

                        <h3>Secure Remote Access</h3>
                        <p>Monitor your operations from anywhere with confidence. We configure secure VPN access that allows you to view live and recorded footage on your phone or computer without exposing your system directly to the internet.</p>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Content -->
    </div>
</template>
<script>
    export default {
        name: 'CameraNVR'
    }
</script>
